import { render } from "./InscricaoForm.vue?vue&type=template&id=0238ce22&scoped=true"
import script from "./InscricaoForm.vue?vue&type=script&lang=js"
export * from "./InscricaoForm.vue?vue&type=script&lang=js"

import "./InscricaoForm.vue?vue&type=style&index=0&id=0238ce22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0238ce22"]])

export default __exports__